import { render, staticRenderFns } from "./AppMutipleFoodUpdate.vue?vue&type=template&id=0d2c1c50&scoped=true&"
import script from "./AppMutipleFoodUpdate.vue?vue&type=script&lang=js&"
export * from "./AppMutipleFoodUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AppMutipleFoodUpdate.vue?vue&type=style&index=0&id=0d2c1c50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2c1c50",
  null
  
)

export default component.exports